<template>
  <div style="margin-bottom:50px;">
    <bj-form :col-span="colSpan" label-position="top" label-width="140px">
      <template v-slot:baseForm>
        <el-row>
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.ImportCSV')">
                    <el-upload accept=".csv,.xls,.xlsx" action="" :limit="1" :auto-upload="false" :on-change="handleChange">
                    <el-button type="primary">{{ $t('billingPage.ClickImport') }}</el-button>
                    </el-upload>
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.Carrier')">
                    <BjSelectLov v-model="params.companyName" :option-list="companyList" />
                </el-form-item>
            </el-col>
            <!-- <el-col v-if="dataInfo.unmatchedItems.length>0" :span="6">
                <el-form-item :label="$t('billingPage.InvoiceDate')">
                  <BjDatePicker v-model="invoiceDate" value-format="yyyy-MM-dd HH:mm:ss" />
                </el-form-item>
            </el-col> -->
            <el-col :span="10" style="margin: 28px 0px 0px 50px;">
                <el-button type="primary" :disabled="!params.companyName || !params.name" @click="_compareShippingCharge">{{ $t('billingPage.COMPARE') }}</el-button>
                <!-- <el-button type="primary" :disabled="!params.companyName || !params.name" @click="importToDb">{{ $t('billingPage.ImportDB') }}</el-button> -->
            </el-col>
        </el-row>
        <!-- <el-row v-if="dataInfo.unmatchedItems.length>0">
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.RecordQty')">
                    <BjInput v-model="dataInfo.recordQty" disabled :maxlength="MAX_LENGTH.DEFAULT" />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.Rating')">
                    <BjInput v-model="dataInfo.totalRatingPrice" disabled :maxlength="MAX_LENGTH.DEFAULT" />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.Actual')">
                    <BjInput v-model="dataInfo.totalActualPrice" disabled :maxlength="MAX_LENGTH.DEFAULT" />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.Diff')">
                    <BjInput v-model="dataInfo.totalDiff" disabled :maxlength="MAX_LENGTH.DEFAULT" />
                </el-form-item>
            </el-col>
            <el-col :span="colSpan">
                <el-form-item :label="$t('billingPage.TotalDiff')">
                    <BjInput v-model="dataInfo.totalDiffPercent" disabled :maxlength="MAX_LENGTH.DEFAULT" />
                </el-form-item>
            </el-col>
        </el-row> -->
      </template>
    </bj-form>
    <BjDivider right-fixed>{{ $t('billingPage.UnMatched') }}</BjDivider>
    <el-table :data="dataInfo.unmatchedItems" style="width: 100%" border>
      <el-table-column type="index" :label="$t('billingPage.index')" align="center" width="100"></el-table-column>
      <el-table-column prop="consignmentNum" :label="$t('billingPage.consignmentNum')" align="center"></el-table-column>
      <el-table-column prop="invoicePrice" :label="$t('billingPage.invoicePrice')" align="center">
        <template slot-scope="scope">${{ scope.row.invoicePrice }}</template>
      </el-table-column>
    </el-table>
    <BjDivider right-fixed>{{ $t('billingPage.MatchedItems') }}
      <template slot="right">
        <el-button type="primary" @click="submit">{{ $t('submitText') }}</el-button>
      </template>
    </BjDivider>
    <el-table :data="dataInfo.matchedItems" @selection-change="handleSelectionChange" style="width: 100%" border>
      <el-table-column type="selection" width="50" :selectable="checkSelectable"></el-table-column>
      <el-table-column type="index" :label="$t('billingPage.index')" align="center" width="50"></el-table-column>
      <el-table-column prop="orderId" :label="$t('billingPage.orderID')" align="center"></el-table-column>
      <el-table-column prop="consignmentNum" :label="$t('billingPage.consignmentNum')" align="center"></el-table-column>
      <el-table-column prop="invoicePrice" :label="$t('billingPage.invoicePrice')" align="center">
        <template slot-scope="scope">${{ scope.row.invoicePrice }}</template>
      </el-table-column>
      <el-table-column prop="ratedPrice" :label="$t('billingPage.ratedPrice')" align="center">
        <template slot-scope="scope">${{ scope.row.ratedPrice }}</template>
      </el-table-column>
      <el-table-column prop="invoiceTotalPrice" :label="$t('billingPage.Carrierinvoicetotalprice')" align="center">
        <template slot-scope="scope">${{ scope.row.invoiceTotalPrice }}</template>
      </el-table-column>
      <el-table-column prop="difference" :label="$t('billingPage.difference')" align="center">
        <template slot-scope="scope">${{ scope.row.difference }}</template>
      </el-table-column>
      <el-table-column prop="totalSurchargedPrice" :label="$t('billingPage.TotalsurchargedPrice')" align="center">
        <template slot-scope="scope">${{ scope.row.totalSurchargedPrice }}</template>
      </el-table-column>
      <el-table-column prop="needChargePrice" :label="$t('billingPage.needChargePrice')" align="center">
        <template slot-scope="scope">${{ scope.row.needChargePrice }}</template>
      </el-table-column>
      <el-table-column prop="ifNeedCharge" :label="$t('billingPage.ifNeedCharge')" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.ifNeedCharge ? 'success' : 'info'">
            {{ $t(STATUS_YES_TRUE.bjGet(scope.row.ifNeedCharge)) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="clientCode" :label="$t('billingPage.clientCode')" align="center"></el-table-column>
      <el-table-column prop="marginRate" :label="$t('billingPage.MarginRate')" align="center"></el-table-column>
    </el-table>
    <!-- <BjDivider>{{ $t('billingPage.Surcharge') }}
      <template slot="right">
        <el-button type="primary" :disabled="dataInfo.surchargeTransactions.length==0" @click="gotoCharge">{{ $t('billingPage.CHARGE') }}</el-button>
      </template>
    </BjDivider>
    <el-table :data="dataInfo.surchargeTransactions" style="width: 100%" border>
      <el-table-column prop="index" :label="$t('billingPage.index')" align="center" width="100"></el-table-column>
      <el-table-column prop="orderID" :label="$t('billingPage.Internal')" align="center">
        <template slot-scope="scope">
          <span class="link" @click="$toBusinessOrderInternalView(scope.row.orderID, false)">{{ scope.row.orderID }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="companyName" :label="$t('billingPage.companyName')" align="center"></el-table-column>
      <el-table-column prop="consignmentID" :label="$t('billingPage.Consignment')" align="center"></el-table-column>
      <el-table-column prop="surchargeAmount" :label="$t('billingPage.SurchargeAmount')" align="center">
        <template slot-scope="scope">
          <span style="color:red">${{ scope.row.surchargeAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="surchargeDetail" :label="$t('billingPage.SurchargeDetail')" align="center"></el-table-column>
      <el-table-column prop="surchargeName" :label="$t('billingPage.SurchargeName')" align="center"></el-table-column>
      <el-table-column prop="isCharged" :label="$t('billingPage.IsCharged')" align="center"></el-table-column>
    </el-table> -->
  </div>
</template>

<script>
import { billApi } from '@/api';
import { STATUS_YES_TRUE } from '@/utils/constants';
export default {
  props: {
    dataInfo: {
        type: Object,
        default: () => {
            return {
                unmatchedItems: [],
                matchedItems: [],
                surchargeTransactions: [],
                recordQty: 0,
                totalRatingPrice: 0,
                totalActualPrice: 0,
                totalDiff: 0,
                totalDiffPercent: 0
            };
        },
    }
  },
  data() {
    return {
        colSpan: 4,
        STATUS_YES_TRUE,
        params: {
            name: '',
            raw: '',
            companyName: ''
        },
        companyList: [ // AUSP, ALLI, COPL, HUNT
            {label: 'AUSP', value: 'AUSP'},
            {label: 'ALLI', value: 'ALLI'},
            {label: 'COPL', value: 'COPL'},
            {label: 'HUNT', value: 'HUNT'},
            {label: 'CAPT', value: 'CAPT'},
            {label: 'DIFE', value: 'DIFE'},
            {label: 'ARMX', value: 'ARMX'},
            {label: 'MAIN', value: 'MAIN' },
            {label: 'TNT', value: 'TNT' },
        ],
        invoiceDate: '',
        tableChangeList: []
    };
  },
  methods: {
    submit(){
      const { fileName, carrierName } = this.dataInfo
      billApi.chargeShippingSurcharge({ fileName, carrierName, surchargeItems:this.tableChangeList }).then(res=>{
        if(!res.failed){
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.$router.go(0)
        }
      })
    },
    checkSelectable(row){
      return row.ifNeedCharge
    },
    handleSelectionChange(val){
      this.tableChangeList = val
    },
    handleChange(e) {
      this.params.name = e.name;
      this.params.raw = e.raw;
    },
    _compareShippingCharge() {
        const { name, raw, companyName } = this.params;
        const formData = new FormData();
        formData.append('file', raw);
        formData.append('name', name);
        formData.append('carrierName', companyName);
        this.$emit('compare', formData);
    },
    importToDb() {
        const obj = {};
        this.dataInfo.matchedItems.forEach(item => {
            obj[item.orderID] = item.ratingPrice;
        });
        this.$emit('importToDb', {
            fileName: this.params.name,
            invoiceDate: this.invoiceDate,
            orderCostMap: obj
        });
    },
    gotoCharge() {
        this.$emit('gotoCharge', {
            fileName: this.params.name,
            carrierName: this.params.companyName,
            surchargeChargeItems: this.dataInfo.surchargeTransactions.map(item => {
                return {
                    orderID: item.orderID,
                    clientCode: item.companyName,
                    surchargeAmount: item.surchargeAmount,
                    surchargeItem: item.surchargeName
                };
            })
        });
    }
  }
};
</script>
